module.exports = __webpack_public_path__ + "img/game_sign_list_banner.be9385fa.png";